import { MapTo } from '@adobe/aem-react-editable-components';
const AEM_FUNCTIONS = 'yme/components/maintenance-hero-section';
import { MaintenanceHeroSection } from './MaintenanceHeroSection';
import { isMaintenanceHeroSectionEmpty } from './helpers';
const maintenanceHeroSectionEditConfig = {
    emptyLabel: 'MaintenanceHeroSection',
    isEmpty: isMaintenanceHeroSectionEmpty,
};
export default MapTo(AEM_FUNCTIONS)(MaintenanceHeroSection, maintenanceHeroSectionEditConfig);
